var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromoRegistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0105 0.668494C21.7342 0.65098 27.9867 6.89475 28.0043 14.636C28.0218 22.3509 21.778 28.6122 14.0368 28.6297C6.32181 28.6473 0.0605196 22.4035 0.0430055 14.6623C0.0254914 6.93854 6.26927 0.686008 14.0105 0.668494ZM6.76842 14.2857C8.73 16.2473 10.7003 18.2089 12.6444 20.1529C15.902 16.8953 19.1859 13.6114 22.4523 10.345C21.8218 9.71452 21.1738 9.0665 20.4907 8.38345C17.8724 11.0018 15.2452 13.6289 12.5831 16.2823C11.2695 14.9688 9.96474 13.664 8.67745 12.3679C8.04695 13.0159 7.39892 13.6552 6.76842 14.2857Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoRegistration);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/promo-registration.7a356f5fc1ac6d57ae8849f3eee7144c.svg";
export { ForwardRef as ReactComponent };